import Vue from 'vue';
import Action from '@/components/Action/Action.vue';
import { RootElementAttrsHolder } from '@/plugins/RootElementAttrsPlugin';
import { JSONParser } from '@/utils/JSONParser';
import {Settings} from "@/components/Action/types";

export function createActionWidget(el: Element) {
    if(!el) return;
    const rootAttrs = new RootElementAttrsHolder(el);
    const parser = new JSONParser('createActionWidget');

    const settings = el.getAttribute('data-settings');

    const props: Settings = {
        settings: parser.parse(settings),
    };

    return new Vue({
        el,
        name: 'Action',
        rootAttrs,
        render(h) {
            return h(Action, { props });
        },
    });
}
